import React, { createContext, useContext, useState, ReactNode } from "react";
import { onEnterChattingParams } from "@src/pages/auctionAgent/chatting";

interface ChattingRoomContextType {
    chattingRoomFromContext: onEnterChattingParams | null;
    setChattingRoomFromContext: (info: onEnterChattingParams | null) => void;
}

const ChattingRoomContext = createContext<ChattingRoomContextType | undefined>(undefined);

export const ChattingRoomProvider = ({ children }: { children: ReactNode }) => {
    const [chattingRoomFromContext, setChattingRoomFromContext] = useState<onEnterChattingParams | null>(null);

    return (
        <ChattingRoomContext.Provider value={{ chattingRoomFromContext, setChattingRoomFromContext }}>
            {children}
        </ChattingRoomContext.Provider>
    );
};

export const useChattingRoomFromContext = () => {
    const context = useContext(ChattingRoomContext);
    if (context === undefined) {
        throw new Error("useChattingRoom must be used within a ChattingRoomProvider");
    }
    return context;
};
